__turbopack_context__.v({
  "cards": "b1zV_q_cards",
  "cardsWeb": "b1zV_q_cardsWeb",
  "category": "b1zV_q_category",
  "container": "b1zV_q_container",
  "containerCard": "b1zV_q_containerCard",
  "h3Platform": "b1zV_q_h3Platform",
  "image": "b1zV_q_image",
  "imageContainer": "b1zV_q_imageContainer",
  "noPaddingCard": "b1zV_q_noPaddingCard",
  "pPlatform": "b1zV_q_pPlatform",
  "paragraph": "b1zV_q_paragraph",
  "rowEtc": "b1zV_q_rowEtc",
  "textH2": "b1zV_q_textH2",
  "title": "b1zV_q_title",
});
